import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FuseReadOnlyComponent from './FuseReadOnlyComponent';
import FuseSwitch from './FuseSwitch';
import FuseInfoTooltip from './FuseTooltip/FuseInfoTooltip';

/**
 * This is a fuse switch with the ReadOnly property changed to render what we need it to, according to
 * the new policy specs. See FuseReadOnlyComponent for a better description of the reason we do this.
 * */
class FuseReadOnlySwitch extends Component {
    static propTypes = {
        ...FuseReadOnlyComponent.PropType,
        ...FuseSwitch.PropType,
        tooltip: PropTypes.node,
        tooltipProps: PropTypes.shape(FuseInfoTooltip.propTypes),
        qa: PropTypes.string.isRequired,
    };

    render = () => {
        const { tooltipProps, ...props } = this.props;

        return <FuseReadOnlyComponent
            component={FuseSwitch}
            readOnlyLabel={this.props.header}
            readOnlyValue={this.props.store.getValue() ? 'Enabled' : 'Disabled'}
            headerInfo={this.props.tooltip}
            headerInfoPosition={tooltipProps?.position}
            {...props}
        />;
    }
}

export default observer(FuseReadOnlySwitch);
